module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("Retirada id #" + _vm._s(_vm.preretirada.id) + " prevista para\n        " + _vm._s(_vm.moment(_vm.preretirada.dataPrevista.date).format('L')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_vm._v("Pagador:")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 font-bold"
  }, [_vm._v(_vm._s(_vm.preretirada.nomePagador))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_vm._v("Documento:")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 font-bold"
  }, [_vm._v(_vm._s(_vm.preretirada.documentoPagador))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_vm._v("Valor:")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 font-bold"
  }, [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.preretirada.valor)))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_vm._v("Referência:")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 font-bold"
  }, [_vm._v(_vm._s(_vm.preretirada.referencia))])]), _vm._v(" "), (_vm.preretirada.favorecido === _vm.FAVORECIDO_APL) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_vm._v("Pix pagador:")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 font-bold"
  }, [_vm._v(_vm._s(_vm.preretirada.chavePixPagador))])]) : _vm._e(), _vm._v(" "), (_vm.preretirada.status === _vm.STATUS_PENDENTE) ? _c('div', [_c('div', {
    staticClass: "row m-t"
  }, [(_vm.preretirada.favorecido === _vm.FAVORECIDO_DETRO) ? _c('form', {
    staticClass: "bs-example form-horizontal form-grv",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.consultar($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.referencia),
      expression: "referencia"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Digite o número de referência",
      "type": "text"
    },
    domProps: {
      "value": (_vm.referencia)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.referencia = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.preretirada.favorecido === _vm.FAVORECIDO_APL) ? _c('form', {
    staticClass: "bs-example form-horizontal form-grv",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.registrarChavePix($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chavePixPagador),
      expression: "chavePixPagador"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Insira a chave pix do pagador",
      "type": "text"
    },
    domProps: {
      "value": (_vm.chavePixPagador)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.chavePixPagador = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(1)]) : _vm._e()]), _vm._v(" "), (_vm.emitirRespostaConsultaBoleto) ? _c('div', [_c('div', {
    staticClass: "alert m-t",
    class: _vm.consultaBoleto.pago ? 'alert-success' : 'alert-danger'
  }, [(_vm.consultaBoleto.naoEncontrado) ? _c('div', [_vm._v("\n            Registro de "), _c('strong', [_vm._v("boleto não encontrado")]), _vm._v(". Referência: " + _vm._s(_vm.consultaBoleto.referencia) + "\n          ")]) : (_vm.consultaBoleto.pago) ? _c('div', [_vm._v("\n            Boleto pago\n          ")]) : _c('div', [_vm._v("\n            Não pago\n          ")])])]) : _vm._e(), _vm._v(" "), (!_vm.pagamentoProcessado && !_vm.pagamentoCancelado) ? _c('div', {
    staticClass: "row m-t"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "m-b"
  }, [_vm._v("Ações")]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.definirPago
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Definir como pago")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.cancelar
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Cancelar Pré-Retirada")])]), _vm._v(" "), (_vm.confirmarPagamento) ? _c('div', {
    staticClass: "m-t"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v(" Valor: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pagamamento.valor),
      expression: "pagamamento.valor"
    }, {
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "R$ 0,00",
      "type": "text",
      "disabled": !_vm.isAdministradorExclusivo
    },
    domProps: {
      "value": (_vm.pagamamento.valor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pagamamento, "valor", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.confirmarPagamentoAction
    }
  }, [_vm._v("Confirmar Pagamento")])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-t-xs"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v(" Data de pagamento: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pagamamento.dataPagamento),
      expression: "pagamamento.dataPagamento"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "dd/mm/yyyy",
      "type": "text"
    },
    domProps: {
      "value": (_vm.pagamamento.dataPagamento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pagamamento, "dataPagamento", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  })])]) : _vm._e(), _vm._v(" "), (_vm.confirmarPagamento || _vm.alertaConfirmarCancelamento) ? _c('div', {
    staticClass: "bg-warning lter b-b wrapper-md m-t "
  }, [_vm._m(2)]) : _vm._e()])]) : (_vm.pagamentoProcessado) ? _c('div', {
    staticClass: "row m-t"
  }, [_vm._m(3)]) : _c('div', {
    staticClass: "row m-t"
  }, [_c('div', {
    staticClass: "col-xs-12 text-danger"
  }, [_vm._v("\n          Pagamento cancelado.\n        ")])])]) : _c('div', [_vm._v("\n      Status da Retirada: "), _c('strong', {
    class: 'text-' + _vm.StatusPreRetirada[_vm.preretirada.status].class
  }, [_vm._v(_vm._s(_vm.StatusTitlePreRetirada(_vm.preretirada.status)))]), _vm._v(" "), (_vm.preretirada.status === _vm.STATUS_PAGO) ? _c('div', {
    staticClass: "row m-t"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_vm._v("Data do Pagamento:")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 font-bold"
  }, [_vm._v(_vm._s(_vm.moment(_vm.preretirada.dataPagamento.date).format('L')))])]) : _vm._e(), _vm._v(" "), (_vm.preretirada.status === _vm.STATUS_PAGO) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_vm._v("Referência Informada:")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 font-bold"
  }, [_vm._v(_vm._s(_vm.preretirada.referenciaPagamento))])]) : _vm._e(), _vm._v(" "), (_vm.preretirada.status === _vm.STATUS_PAGO) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.preretirada.status === _vm.STATUS_PENDENTE) ? _c('a', {
    staticClass: "btn btn-xs btn-primary btn-block m-t-xs",
    attrs: {
      "href": _vm.preretirada.urlBoleto,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-barcode"
  }), _vm._v(" Ver boleto\n          ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isAdministradorExclusivo) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('btn-altera-data-pagamento-preretirada', {
    attrs: {
      "pre-retirada-id": _vm.preretirada.id
    },
    on: {
      "dataAlterada": _vm.handleDataPagamentoAlterada
    }
  }), _vm._v(" "), (_vm.preretirada.favorecido === _vm.FAVORECIDO_APL) ? _c('btn-altera-pix-pagador', {
    staticClass: "m-l",
    attrs: {
      "pre-retirada-id": _vm.preretirada.id
    },
    on: {
      "pixAlterado": _vm.handlePixAlterado
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m-t-sm m-b-sm m-l"
  }, [_c('a', {
    staticClass: "btn btn-default font-bold btn-dark",
    on: {
      "click": _vm.setStatusPendente
    }
  }, [_vm._v("Voltar pré-retirada para pendente")])])], 1) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Consultar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Salvar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h5 text-black"
  }, [_c('strong', [_vm._v("Atenção")]), _c('br'), _vm._v("\n                  Confira os dados da GRV antes de confirmar essa ação\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('strong', [_vm._v("Pagamento processado com sucesso.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c01124f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/preretirada/components/ConsultaPagamento.vue
// module id = 1786
// module chunks = 17